import React, { useState, useEffect } from 'react';
import HoursForm from './HoursForm';
import HoursText from './HoursText';
import HoursSkeleton from './HoursSkeleton';
import { useEyeconxStore } from '../../../../../store/eyeconxStore';
import settingsService from '../../../../../services/settings.service';
import { showError, showSuccess } from '../../../../../utils/ecxSwal';
import ClinicSettingsSectionHeader from '../subparts/ClinicSettingsSectionHeader';
import ClinicSettingsCancelButton from '../subparts/ClinicSettingsCancelButton';

const Hours = () => {
    const [hours, setHours] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const clinicId = useEyeconxStore((state) => state.user.clinicId);

    useEffect(() => {
        const fetchHours = async () => {
            try {
                setIsLoading(true);
                const res = await settingsService.getHours(clinicId);
                setHours(res.data);
            } catch (error) {
                console.error('Error fetching hours:', error);
                showError({
                    title: 'Load Failed',
                    text: 'Unable to load clinic hours. Please try again.',
                });
            } finally {
                setIsLoading(false);
            }
        };

        fetchHours();
    }, [clinicId]);

    const handleSave = async (updatedHours) => {
        setIsSaving(true);

        try {
            const res = await settingsService.updateHours(clinicId, updatedHours);
            setHours(res.data);
            setIsEditing(false);
            await showSuccess({
                title: 'Hours Saved',
                text: 'Your clinic hours were updated successfully.',
            });
        } catch (error) {
            console.error('Error saving hours:', error);
            showError({
                title: 'Save Failed',
                text: 'Unable to update clinic hours. Please try again.',
            });
        } finally {
            setIsSaving(false);
        }
    };

    if (isLoading) {
        return (
            <>
                <ClinicSettingsSectionHeader
                    title="Clinic Hours"
                    icon="bi-clock"
                    subtitle="Set your regular weekly operating hours"
                />
                <HoursSkeleton />
            </>
        );
    }

    return (
        <>
            <ClinicSettingsSectionHeader
                title="Clinic Hours"
                icon="bi-clock"
                subtitle="Set your regular weekly operating hours"
                actions={(
                    isEditing ? (
                        <ClinicSettingsCancelButton onClick={() => setIsEditing(false)} disabled={isSaving} />
                    ) : (
                        <button
                            className="btn btn-sm btn-light-primary rounded-pill"
                            onClick={() => setIsEditing(true)}
                            type="button"
                        >
                            <i className="bi bi-pencil me-1"></i>
                            Edit
                        </button>
                    )
                )}
            />
            {hours && hours.length > 0 && (
                isEditing ? (
                    <HoursForm
                        hours={hours}
                        onSave={handleSave}
                        isSaving={isSaving}
                    />
                ) : (
                    <HoursText hours={hours} />
                )
            )}
        </>
    );
};

export default Hours;
